import { Modal, ModalBody, modalConnect } from "@modal";
import { ceModalInsertFormClose } from "@js/actions/studio/campaign_content_section/modal_insert_form.js";

const ModalInsertForm = modalConnect((props) => {
  const Field = (p) => {
    let select = (e) => {
      e.preventDefault();
      let formCode = p.replacement_code;

      if (props.format === "html") {
        // Create a link for HTML editors
        formCode = `<a href="${formCode}">${p.name}</a>`;
      }

      props.connector.trigger({ type: "insert", value: formCode });
      props.dispatch(ceModalInsertFormClose());
    };
    return (
      <a
        onClick={select}
        href="#"
        className={`insert-custom-field button`}
      >
        {p.name}
      </a>
    );
  };

  return (
    <Modal
      title={t("buttons.insert_form")}
      onCancel={() => props.dispatch(ceModalInsertFormClose())}
    >
      <ModalBody>
        {props.forms.length === 0 ? (
          <div>{t("empty_table.web_forms_modal")}</div>
        ) : (
          props.forms.map((form, index) => <Field key={index} {...form} />)
        )}
      </ModalBody>
    </Modal>
  );
});

export default ModalInsertForm;
